import { Action } from '@ngrx/store'
import * as CommunitiesTypes from './communities.types'
import { Community } from './communities.interface'

export class FetchCommunitiesRequest implements Action {
  readonly type = CommunitiesTypes.FETCH_COMMUNITIES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchCommunitiesSuccess implements Action {
  readonly type = CommunitiesTypes.FETCH_COMMUNITIES_SUCCESS
  constructor(
    public payload: Community[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchCommunitiesFailure implements Action {
  readonly type = CommunitiesTypes.FETCH_COMMUNITIES_FAILURE
  constructor(public payload: any) {}
}

export class FetchCommunityRequest implements Action {
  readonly type = CommunitiesTypes.FETCH_COMMUNITY_REQUEST
  constructor(public id: number) {}
}

export class FetchCommunitySuccess implements Action {
  readonly type = CommunitiesTypes.FETCH_COMMUNITY_SUCCESS
  constructor(public payload: Community) {}
}

export class FetchCommunityFailure implements Action {
  readonly type = CommunitiesTypes.FETCH_COMMUNITY_FAILURE
  constructor(public payload: any) {}
}

export class DeleteCommunityRequest implements Action {
  readonly type = CommunitiesTypes.DELETE_COMMUNITY_REQUEST
  constructor(public id: number) {}
}

export class DeleteCommunitySuccess implements Action {
  readonly type = CommunitiesTypes.DELETE_COMMUNITY_SUCCESS
  constructor() {}
}

export class DeleteCommunityFailure implements Action {
  readonly type = CommunitiesTypes.DELETE_COMMUNITY_FAILURE
  constructor(public payload: any) {}
}

export class CreateCommunityRequest implements Action {
  readonly type = CommunitiesTypes.CREATE_COMMUNITY_REQUEST
  constructor(public payload) {}
}

export class CreateCommunitySuccess implements Action {
  readonly type = CommunitiesTypes.CREATE_COMMUNITY_SUCCESS
  constructor() {}
}

export class CreateCommunityFailure implements Action {
  readonly type = CommunitiesTypes.CREATE_COMMUNITY_FAILURE
  constructor(public payload: any) {}
}

export class UpdateCommunityRequest implements Action {
  readonly type = CommunitiesTypes.UPDATE_COMMUNITY_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateCommunitySuccess implements Action {
  readonly type = CommunitiesTypes.UPDATE_COMMUNITY_SUCCESS
  constructor() {}
}

export class UpdateCommunityFailure implements Action {
  readonly type = CommunitiesTypes.UPDATE_COMMUNITY_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = CommunitiesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = CommunitiesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateCommunityRequest
  | UpdateCommunitySuccess
  | UpdateCommunityFailure
  | FetchCommunitiesSuccess
  | FetchCommunitiesFailure
  | FetchCommunitiesRequest
  | FetchCommunitySuccess
  | FetchCommunityFailure
  | FetchCommunityRequest
  | CreateCommunityRequest
  | CreateCommunitySuccess
  | CreateCommunityFailure
  | DeleteCommunityRequest
  | DeleteCommunitySuccess
  | DeleteCommunityFailure
  | SetDefaultData
  | UpdateField
  | FetchCommunitiesRequest
  | FetchCommunitiesSuccess
  | FetchCommunitiesFailure
